"use strict";
/**
 * Created on 02 05 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * <p>
 * Another, simplified, representation of a product in promotion. In contrast of {@link WindowItem}, entity consists of only crucial
 * attributes related to promotion, such as promotion time interval (both on entire promotion and product level), group of sites (also
 * both on entire promotion and product level), product's promotion price. The state of relevance of facts is indicated by the workflow
 * state that is modeled as number. The target application should use configured set of states for an application's use cases.
 * </p>
 *
 * <p>
 * To ease further processing, entity encapsulates (duplicates) some attributes from another entities, such as {@link Promotion}. Entity
 * does not work with concept of {@link Window window}, only expresses the pure fact of association of product in promotion.
 * </p>
 *
 * <p>
 * <b>This entity is not intended to be used as reference within another entities. Deleted entities within external system will not exist
 * within target system because they will be deleted within the import.</b>
 * </p>
 *
 * <p>
 * <b>Mentioned information about relevant sites intersection below is not related to the number of sites algorithm. In other words, the
 * validity of the sites is not validated against the site assortment.</b>
 * </p>
 *
 * @author JMe
 */


var PromotionProduct =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(PromotionProduct, _StateDomainObject_1$);

  /**
   * Ctor.
   *
   * @param id Internal id of entity.
   * @param externalId External identification of entity within external system (conjunction of all parts of primary key).
   * @param productId Refers to {@link Product.id}.
   * @param groupOfSitesId The group of sites defined on product level. It does not mean, that product is promoted on all sites of group
   *        of sites which are valid at least in day of promotional validity. Validity of associated sites should be validated against
   *        {@link #validFrom} and {@link #validTo}. Intersection of resulted sites from this GoS and resulted sites from
   *        {@link #parentGroupOfSitesId} should be the set of relevant sites.
   * @param validFrom Start day of the promotion price validity.
   * @param validTo End day of the promotion price validity.
   * @param priceValue The promotional price incl. vat.
   * @param pricePriority The priority of the promotional price. Priority corresponds with a priority of price list, but is not limited
   *        only to that usage. In any case, a lower value should mean a higher priority.
   * @param workflowState Workflow state (or just only state) of the facts, modelled as number as it is within external system.
   * @param promotionId Refers to {@link Promotion.id}.
   * @param parentGroupOfSitesId Refers to {@link Promotion.groupOfSitesId}. Validity of associated sites should be validated against
   *        interval formed by {@link #parentValidFrom} and {@link #parentValidTo}. Intersection of resulted sites from this GoS and
   *        resulted sites from {@link #groupOfSitesId} should be the set of relevant sites.
   * @param parentValidFrom Refers to {@link Promotion.dateFrom}.
   * @param parentValidTo Refers to {@link Promotion.dateTo}.
   * @param sites Set of sites computed as intersection of sites from {@link #groupOfSitesId} and {@link #parentGroupOfSitesId}. Set is
   *        (or at least should be) recalculated every day. Set of sites is computed with respect to corresponding time interval.
   * @param stateFlags
   * @param returnPossibility This means the remaining stock after the sellout will be returned to the supplier.
   * @param processed Defines whether an instance was processed within the import. In normal situation, this value will be equal to false.
   */
  function PromotionProduct(id, externalId, productId, groupOfSitesId, validFrom, validTo, priceValue, pricePriority, workflowState, promotionId, parentGroupOfSitesId, parentValidFrom, parentValidTo, sites, stateFlags, returnPossibility, processed) {
    var _this;

    _classCallCheck(this, PromotionProduct);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionProduct).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.productId = productId;
    _this.groupOfSitesId = groupOfSitesId;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    _this.priceValue = priceValue;
    _this.pricePriority = pricePriority;
    _this.workflowState = workflowState;
    _this.promotionId = promotionId;
    _this.parentGroupOfSitesId = parentGroupOfSitesId;
    _this.parentValidFrom = parentValidFrom;
    _this.parentValidTo = parentValidTo;
    _this.sites = sites;
    _this.stateFlags = stateFlags;
    _this.returnPossibility = returnPossibility;
    _this.processed = processed;
    return _this;
  }

  return PromotionProduct;
}(StateDomainObject_1.StateDomainObject);

exports.PromotionProduct = PromotionProduct;

PromotionProduct.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionProduct.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    productId: builder.str('productId'),
    groupOfSitesId: builder.str('groupOfSitesId'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN),
    priceValue: builder.bigNum('priceValue'),
    pricePriority: builder.num('pricePriority'),
    workflowState: builder.num('workflowState'),
    promotionId: builder.str('promotionId'),
    parentGroupOfSitesId: builder.str('parentGroupOfSitesId'),
    parentValidFrom: builder.date('parentValidFrom', DateParser_1.DateParser.ISO_PATTERN),
    parentValidTo: builder.date('parentValidTo', DateParser_1.DateParser.ISO_PATTERN),
    sites: builder.setOf(builder.id('sites')),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag),
    returnPossibility: builder.bool('returnPossibility'),
    processed: builder.bool('processed')
  };
}();